//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "Articles",
  emits: ['close'],
  props: {
    content: {
      type: Array,
      required: true,
      default() {
        return [];
      }
    },
    activeCategory: {
      type: String,
      reuqired: false,
      default() {
        return '';
      }
    },
    sectionType: {
      type: String,
      reuqired: false,
      default() {
        return '';
      }
    },
  },
  data() {
    return {
      isShow: true,
      articlesCounter: 3,
    }
  },
  computed: {
    visibleContent: function () {
      if (this.sectionType === 'lens_option') {
        return 'lens_option'
      }
      return "articles"
    },

    getArticlesCounter() {
      if (this.activeCategory === '5') {
        return this.content.length;
      }
      return this.articlesCounter;
    }
  }
};
